import { ButtonProps } from '@mantine/core';
import { IconArrowRight, IconExternalLink } from '@tabler/icons-react';
import React from 'react';
import { Link } from 'react-router-dom';
import { BasicButton } from 'src/design/atoms/BasicButton';

// react-router import is a permanent, documented exemption to lib's no-router rule (see @registry below).
export type ILinkButtonProps = Omit<ButtonProps, 'component'> & {
  to: string;
  target?: React.HTMLAttributeAnchorTarget;
  children?: React.ReactNode;
};

const DefaultProps: Partial<ButtonProps> = {
  variant: 'subtle',
  color: 'blue',
  fullWidth: false,
  size: 'compact-sm',
  w: 'fit-content',
};

/** @registry Router-aware Mantine Button rendered as a react-router Link; use for in-app navigation styled as a button. Permanently exempted from lib's no-router-import rule. */
export const LinkButton = React.forwardRef<HTMLAnchorElement, ILinkButtonProps>(
  ({ children, to, target, ...props }, ref) => {
    const rightSection =
      target === '_blank' ? (
        <IconExternalLink size={16} />
      ) : (
        <IconArrowRight size={16} />
      );

    return (
      <BasicButton
        {...DefaultProps}
        rightSection={props.rightSection || rightSection}
        {...props}
        component={Link}
        to={to}
        target={target}
        ref={ref}
      >
        {children}
      </BasicButton>
    );
  },
);
LinkButton.displayName = 'LinkButton';
